var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "card-item mt-6" },
              [
                _c("h3", { staticClass: "has-text-centered" }, [
                  _vm._v("Solicitudes de Portabilidad Financiera"),
                ]),
                !_vm.isLoading && _vm.pendingRequests.length === 0
                  ? _c("h4", [
                      _vm._v(
                        " Felicitaciones, actualmente no hay solicitudes que atender "
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "field is-grouped",
                    attrs: { id: "filter-buttons" },
                  },
                  [
                    _vm.pendingRequests.length
                      ? _c(
                          "p",
                          { staticClass: "control" },
                          [
                            _c(
                              "b-dropdown",
                              {
                                attrs: { "aria-role": "list" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "trigger",
                                      fn: function ({ active }) {
                                        return _c(
                                          "button",
                                          {
                                            staticClass: "button is-primary",
                                            attrs: {
                                              id: "filter-button-dropdown",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.selectedOptions)
                                              ),
                                            ]),
                                            _c("b-icon", {
                                              attrs: {
                                                icon: active
                                                  ? "angle-up"
                                                  : "angle-down",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3631261915
                                ),
                                model: {
                                  value: _vm.selectedOptions,
                                  callback: function ($$v) {
                                    _vm.selectedOptions = $$v
                                  },
                                  expression: "selectedOptions",
                                },
                              },
                              [
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      id: "filter-button-all",
                                      value: "Todas",
                                      "aria-role": "listitem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setTypeFilter("ALL")
                                      },
                                    },
                                  },
                                  [_vm._v(" Todas ")]
                                ),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      id: "filter-button-debtor",
                                      value: "Clientes",
                                      "aria-role": "listitem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setTypeFilter("CLIENTS")
                                      },
                                    },
                                  },
                                  [_vm._v(" Clientes ")]
                                ),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      id: "filter-button-financial-institution",
                                      value: "Instituciones Financieras",
                                      "aria-role": "listitem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setTypeFilter(
                                          "FINANCIAL_INSTITUTION"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Instituciones Financieras ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-rounded",
                          attrs: { id: "download-button-report" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadReport()
                            },
                          },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "download" } }),
                          _c("span", [_vm._v("Descargar informe")]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm.pendingRequests.length
                  ? _c(
                      "h4",
                      { staticClass: "search-heading" },
                      [
                        _vm._v(" Solicitudes abiertas "),
                        _c(
                          "b-field",
                          {
                            staticClass: "field is-pulled-right",
                            attrs: { horizontal: "" },
                          },
                          [
                            _c("b-input", {
                              attrs: {
                                id: "search-input",
                                type: "search",
                                icon: "search",
                                "icon-clickable": "",
                                placeholder: "nombre, apellido, rut, email",
                                size: "is-small",
                                rounded: "",
                              },
                              on: { input: _vm.filterPendingRequests },
                              model: {
                                value: _vm.searchInputVal,
                                callback: function ($$v) {
                                  _vm.searchInputVal = $$v
                                },
                                expression: "searchInputVal",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isLoading
                  ? _c(
                      "transition-group",
                      {
                        staticClass: "card-requests",
                        attrs: {
                          name: "requests-transition",
                          appear: "",
                          tag: "div",
                        },
                      },
                      _vm._l(_vm.filteredRequests, function (request, i) {
                        return _c(
                          "div",
                          {
                            key: `request-${i}`,
                            staticClass: "request card-item",
                            class: { active: _vm.extendedRequest === i },
                            style: { "--i": i },
                          },
                          [
                            _c("div", { staticClass: "request-info" }, [
                              _c("div", { attrs: { id: `id-number-${i}` } }, [
                                _c("span", [_vm._v("RUT:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatIdNumber(
                                        request.debtor.idNumber
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", [
                                _c("span", [_vm._v("Solicita:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      request.sender === "DEBTOR"
                                        ? "Cliente"
                                        : request.sender ===
                                          "DEBTOR_PORTABILITY"
                                        ? "Cliente - Portabilidad"
                                        : "Institución financiera"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", [
                                _c("span", [_vm._v("Fecha de solicitud:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(request.createdAt)) +
                                    " "
                                ),
                              ]),
                              _c("div", [
                                _c("span", [_vm._v("Días en espera:")]),
                                _vm._v(" " + _vm._s(request.lateDays) + " "),
                              ]),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      id: `extend-button-${i}`,
                                      href: "#",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.extendedRequest =
                                          _vm.extendedRequest === i
                                            ? undefined
                                            : i
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "fa fa-lg transition-slow",
                                      class:
                                        _vm.extendedRequest === i
                                          ? "fa-minus-circle"
                                          : "fa-plus-circle",
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "request-content transition-fast",
                                attrs: {
                                  id: `financial-portability-request-details-${i}`,
                                },
                              },
                              [
                                _c("div", { staticClass: "request-details" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex-box-content" },
                                    [
                                      _c("div", { staticClass: "req-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "req-column" },
                                          [
                                            _c("h4", [
                                              _vm._v("Datos de la solicitud"),
                                            ]),
                                            _c("ul", [
                                              request.sender ===
                                              "FINANCIAL_INSTITUTION"
                                                ? _c("section", [
                                                    _c("li", [
                                                      _c("h5", [
                                                        _vm._v(
                                                          "Institución financiera"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          request
                                                            .financialInstitution
                                                            .businessName
                                                        ) + " "
                                                      ),
                                                    ]),
                                                    _c("li", [
                                                      _c("h5", [
                                                        _vm._v(
                                                          "Nombre de contacto"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          request
                                                            .financialInstitution
                                                            .contact.name
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _c("li", [
                                                _c("h5", [
                                                  _vm._v("Correo electrónico"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      request[
                                                        request.sender ===
                                                          "DEBTOR" ||
                                                        "DEBTOR_PORTABILITY"
                                                          ? "debtor"
                                                          : "financialInstitution"
                                                      ].contact.email
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c("li", [
                                                _c("h5", [
                                                  _vm._v("Nº de solicitud"),
                                                ]),
                                                _c(
                                                  "small",
                                                  { staticClass: "is-size-7" },
                                                  [_vm._v(_vm._s(request._id))]
                                                ),
                                              ]),
                                              request.companyOperationsIds
                                                ? _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "companyOpId",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c("h5", [
                                                            _vm._v(
                                                              "Productos a portabilizar"
                                                            ),
                                                          ]),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "is-size-7",
                                                            },
                                                            _vm._l(
                                                              request.companyOperationsIds,
                                                              function (x) {
                                                                return _c(
                                                                  "p",
                                                                  { key: x },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          x.idProduct
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]),
                                                        _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "typeCredit",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Tipo de crédito"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "is-size-7",
                                                            },
                                                            _vm._l(
                                                              request.companyOperationsIds,
                                                              function (x) {
                                                                return _c(
                                                                  "p",
                                                                  { key: x },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          x.typeProduct
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              request.operationsAddresses
                                                ? _c("li", [
                                                    _c("h5", [
                                                      _vm._v("Propiedades"),
                                                    ]),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "is-size-7",
                                                      },
                                                      _vm._l(
                                                        request.operationsAddresses,
                                                        function (x) {
                                                          return _c(
                                                            "p",
                                                            {
                                                              key: x.streetName,
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    `${
                                                                      x.streetName
                                                                    } #${
                                                                      x.streetNumber
                                                                    } ${
                                                                      x.block
                                                                        ? x.block
                                                                        : ""
                                                                    }, ${
                                                                      x.commune
                                                                    }`
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _c("li", [
                                                _c("h5", [
                                                  _vm._v(
                                                    "¿Incluir todos los productos?"
                                                  ),
                                                ]),
                                                _c(
                                                  "small",
                                                  { staticClass: "is-size-7" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        request.includeAllProducts
                                                          ? "Sí"
                                                          : "No"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c("li", [
                                                _c("h5", [_vm._v("Deudor")]),
                                                _c(
                                                  "small",
                                                  { staticClass: "is-size-7" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        request.debtor.name
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          request.debtor
                                                            .lastName
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "req-column" },
                                          [
                                            _c("h4", [_vm._v("Documentos")]),
                                            _c(
                                              "ul",
                                              [
                                                _vm._l(
                                                  _vm.fieldTypes.filter((x) =>
                                                    x.allowedSenders.includes(
                                                      request.sender
                                                    )
                                                  ),
                                                  function (field, j) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: `field-${j}`,
                                                        attrs: {
                                                          id: `li-${field.id}-${i}`,
                                                        },
                                                      },
                                                      [
                                                        _c("h5", [
                                                          _vm._v(
                                                            _vm._s(field.text)
                                                          ),
                                                        ]),
                                                        request[
                                                          `${field.id}Link`
                                                        ]
                                                          ? _c(
                                                              "p",
                                                              {
                                                                attrs: {
                                                                  id: `${field.id}-${i}`,
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-check",
                                                                }),
                                                                _vm._v(
                                                                  " Ya existe un documento, puedes sobre-escribirlo "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "upload-buttongroup field has-addons",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "control",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "file",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "file-label",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            staticClass:
                                                                              "file-input",
                                                                            attrs:
                                                                              {
                                                                                type: "file",
                                                                                disabled:
                                                                                  _vm.checkUserFeature(
                                                                                    "element.portability-support.button.subir-documentos"
                                                                                  ) ===
                                                                                  false,
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.addFile(
                                                                                    request.originalIndex,
                                                                                    field.id,
                                                                                    $event
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "file-cta",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "file-icon",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fas fa-upload",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "file-label",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Elige"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm.supportResponse[
                                                              request
                                                                .originalIndex
                                                            ] &&
                                                            _vm.supportResponse[
                                                              request
                                                                .originalIndex
                                                            ][field.id]
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "control",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "button is-small is-rounded is-info",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm
                                                                              .isUploading[
                                                                              request
                                                                                .originalIndex
                                                                            ] &&
                                                                            _vm
                                                                              .isUploading[
                                                                              request
                                                                                .originalIndex
                                                                            ][
                                                                              `${field.id}`
                                                                            ],
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.uploadFile(
                                                                                request.originalIndex,
                                                                                request._id,
                                                                                field.id
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm
                                                                          .isUploading[
                                                                          request
                                                                            .originalIndex
                                                                        ] &&
                                                                        _vm
                                                                          .isUploading[
                                                                          request
                                                                            .originalIndex
                                                                        ][
                                                                          `${field.id}`
                                                                        ]
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fas fa-spinner fa-spin",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  " Subir "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm.supportResponse[
                                                          request.originalIndex
                                                        ] &&
                                                        _vm.supportResponse[
                                                          request.originalIndex
                                                        ][field.id]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "is-size-7",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .supportResponse[
                                                                        request
                                                                          .originalIndex
                                                                      ][
                                                                        field.id
                                                                      ].name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                request.sender ===
                                                "FINANCIAL_INSTITUTION"
                                                  ? _c("li", [
                                                      _c("h5", [
                                                        _vm._v(
                                                          "Solicitud firmada por el cliente"
                                                        ),
                                                      ]),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "button is-button-secondary",
                                                          attrs: {
                                                            id: `button-download-request-document-${i}`,
                                                            disabled:
                                                              _vm
                                                                .supportResponse[
                                                                request
                                                                  .originalIndex
                                                              ] &&
                                                              _vm
                                                                .supportResponse[
                                                                request
                                                                  .originalIndex
                                                              ]
                                                                .isDownloadingRequestDocument,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.getClientRequestDocument(
                                                                request._id,
                                                                request.originalIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "icon is-small",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-file-download",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm.supportResponse[
                                                            request
                                                              .originalIndex
                                                          ] &&
                                                          _vm.supportResponse[
                                                            request
                                                              .originalIndex
                                                          ]
                                                            .isDownloadingRequestDocument
                                                            ? _c("span", [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-spinner fa-spin",
                                                                }),
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "Descarga"
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "buttons save-changes is-pulled-right",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-button-secondary",
                                          attrs: {
                                            id: `button-reject-${i}`,
                                            disabled: !_vm.checkUserFeature(
                                              "element.portability-support.button.no-atender"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmRejectRequest(
                                                request._id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" No atender ")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-button-primary",
                                          attrs: {
                                            id: `button-accept-${i}`,
                                            disabled: !_vm.checkUserFeature(
                                              "element.portability-support.button.aceptar"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmAcceptRequest(
                                                request._id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Aceptar ")]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "spinner-content",
                class: _vm.isLoading ? "is-loading" : "is-hidden",
              },
              [_vm._m(0)]
            ),
            _c(
              "b-modal",
              {
                attrs: { id: "modal-accept", "can-cancel": false },
                model: {
                  value: _vm.acceptModal.isActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.acceptModal, "isActive", $$v)
                  },
                  expression: "acceptModal.isActive",
                },
              },
              [
                _c("div", { staticClass: "modal-card-body" }, [
                  _c(
                    "a",
                    {
                      staticClass: "close-modal",
                      on: {
                        click: function ($event) {
                          _vm.acceptModal.isActive = false
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/ui/assets/img/plus-button.svg"),
                        },
                      }),
                    ]
                  ),
                  _c("h3", { staticClass: "modal-title" }, [
                    _vm._v("Confirmar"),
                  ]),
                  _c("section", { staticClass: "modal-card-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(
                          "¿Realmente quieres confirmar la solicitud? Se enviarán los archivos adjuntos a la institución"
                        ),
                      ]),
                      _vm.acceptModal.messageError
                        ? _c(
                            "p",
                            {
                              staticClass: "help is-danger",
                              attrs: { id: "modal-accept-error-message" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errorDictionary.acceptRequest) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "buttons is-pulled-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-secondary",
                          attrs: {
                            id: "button-cancel-accept",
                            rounded: "",
                            size: "is-small",
                          },
                          on: {
                            click: function ($event) {
                              _vm.acceptModal.isActive = false
                            },
                          },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-primary",
                          attrs: {
                            id: "button-confirm-accept",
                            disabled: _vm.rejectModal.disableButton,
                            rounded: "",
                            size: "is-small",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.acceptRequest(
                                _vm.acceptModal.requestId
                              )
                            },
                          },
                        },
                        [_vm._v(" Aceptar solicitud ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "b-modal",
              {
                attrs: { id: "modal-reject", "can-cancel": false },
                model: {
                  value: _vm.rejectModal.isActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.rejectModal, "isActive", $$v)
                  },
                  expression: "rejectModal.isActive",
                },
              },
              [
                _c("div", { staticClass: "modal-card-body" }, [
                  _c(
                    "a",
                    {
                      staticClass: "close-modal",
                      on: {
                        click: function ($event) {
                          _vm.rejectModal.isActive = false
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/ui/assets/img/plus-button.svg"),
                        },
                      }),
                    ]
                  ),
                  _c("h3", { staticClass: "modal-title" }, [
                    _vm._v(
                      "Motivo por el cual no podemos atender la solicitud"
                    ),
                  ]),
                  _c("section", { staticClass: "modal-card-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Mensaje"),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rejectModal.message,
                              expression: "rejectModal.message",
                            },
                          ],
                          staticClass: "textarea",
                          attrs: { id: "reject-comment" },
                          domProps: { value: _vm.rejectModal.message },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.rejectModal,
                                "message",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm.rejectModal.messageError
                        ? _c("p", { staticClass: "help is-danger" }, [
                            _vm._v("Debes escribir un mensaje"),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.rejectModal.backendError
                      ? _c(
                          "p",
                          {
                            staticClass: "help is-danger",
                            attrs: { id: "modal-reject-error-message" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.errorDictionary.rejectRequest) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "buttons is-pulled-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-secondary",
                          attrs: {
                            id: "button-cancel-reject",
                            rounded: "",
                            size: "is-small",
                          },
                          on: {
                            click: function ($event) {
                              _vm.rejectModal.isActive = false
                            },
                          },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-primary",
                          attrs: {
                            id: "button-confirm-reject",
                            disabled: _vm.rejectModal.disableButton,
                            rounded: "",
                            size: "is-small",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.rejectRequest(
                                _vm.rejectModal.requestId,
                                _vm.rejectModal.message
                              )
                            },
                          },
                        },
                        [_vm._v(" No atender ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "b-modal",
              {
                attrs: { id: "modal-download", "can-cancel": false },
                model: {
                  value: _vm.downloadModal.isActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.downloadModal, "isActive", $$v)
                  },
                  expression: "downloadModal.isActive",
                },
              },
              [
                _c("div", { staticClass: "modal-card-body" }, [
                  _c("h3", { staticClass: "modal-title" }, [_vm._v("Error")]),
                  _c("section", { staticClass: "modal-card-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label help is-danger",
                          attrs: { id: "modal-download-file-error-message" },
                        },
                        [
                          _c("i", { staticClass: "fas fa-times-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.errorDictionary.downloadFile) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "buttons is-pulled-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-button-primary",
                        attrs: { id: "button-confirm-accept" },
                        on: {
                          click: function ($event) {
                            _vm.downloadModal.isActive = false
                          },
                        },
                      },
                      [_vm._v(" Ok ")]
                    ),
                  ]),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }